import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { z } from 'zod'
import type { memberCreatorOptionsSchema } from '@super-mega/server/contracts/member'
import { useDebouncedValue } from '@/hooks/use-debounced-value.ts'
import { useTRPC } from '@/trpc/react.ts'

export function useMemberCreatorOptions(
  permission: z.infer<typeof memberCreatorOptionsSchema>['permission'],
  selectedMemberId?: number
) {
  const trpc = useTRPC()
  const [keyword, setKeyword] = useState('')
  const debouncedKeyword = useDebouncedValue(keyword.trim() || undefined)

  const query = useQuery({
    ...trpc.member.creatorOptions.queryOptions({
      permission,
      id: selectedMemberId,
      keyword: debouncedKeyword
    }),
    staleTime: 60_000
  })

  return {
    isLoading: query.isLoading || query.isFetching,
    onSearch: setKeyword,
    options: query.data ?? []
  }
}
